import { render, staticRenderFns } from "./ProjectValuationBuyerTypeTiles.vue?vue&type=template&id=424a9714&scoped=true&"
import script from "./ProjectValuationBuyerTypeTiles.vue?vue&type=script&lang=ts&"
export * from "./ProjectValuationBuyerTypeTiles.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectValuationBuyerTypeTiles.vue?vue&type=style&index=0&id=424a9714&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424a9714",
  null
  
)

export default component.exports